// extracted by mini-css-extract-plugin
module.exports = {"moreText":"FOOG0","moreLink":"_9X9Pw","moreIcon":"Jbqg8"};